import { instance } from "./baseClient";

export const sendEmail = async (email) => {
  return instance.post("email", email);
};
